import React, { useEffect } from 'react';
import HeroBanner from '../components/common/HeroBanner/HeroBanner';

const Car = () => {
  useEffect(() => {
    document.title = 'NEST | Cars';
  }, []);
  return (
    <div>
      <HeroBanner 
        title="Our Cars" 
        breadcrumbs={['Our Car']}
      />
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-md-7 heading-section text-center ftco-animate">
              <h2>Car Listings Coming Soon</h2>
              <p>Check back soon for our vehicle listings.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Car;


